import React, { useRef, useState } from "react";
import { Button, Layout, theme, Flex } from "antd";
import { MenuFoldOutlined, MenuUnfoldOutlined } from "@ant-design/icons";
import HeaderUserbox from "./Userbox";
import HeaderUserboxLoggedIn from "./UserboxLoggedIn";

import Logobox from "./Logobox";
import { NavLink, Link } from "react-router-dom";

import { useSelector } from "react-redux";
const { Header } = Layout;
function MyHeader({ collapsed, setCollapsed, colorBgContainer }) {
  //const [isLoggedIn, setIsLoggedIn] = useState(true);
  const { isLoggedIn } = useSelector((state) => state.auth);

  return (
    <Header
      style={{
        padding: "0px 16px 0px 0px",
        background: colorBgContainer,
      }}
    >
      <Flex justify="space-between" align="center">
        <Logobox collapsed={collapsed} setCollapsed={setCollapsed} />
        {isLoggedIn ? <HeaderUserboxLoggedIn /> : <HeaderUserbox />}
      </Flex>
    </Header>
  );
}

export default MyHeader;
